import { render } from "./ModalBtn.vue?vue&type=template&id=2dc2b834"
import script from "./ModalBtn.vue?vue&type=script&lang=js"
export * from "./ModalBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__